import { NgModule } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
    exports: [
        MatRadioModule,
        MatListModule,
        MatExpansionModule,
        MatProgressSpinnerModule,
        MatBadgeModule,
        MatIconModule,
        MatDividerModule,
        MatTooltipModule,
    ],
})
export class EcheckListtMaterialModule {}
